//Import Images
import athlete from "./images/athlete-small.png";
import goodtimes from "./images/goodtimes-small.png";
import theracer from "./images/theracer-small.png";
import athlete2 from "./images/athlete2.png";
import goodtimes2 from "./images/good-times2.jpg";
import theracer2 from "./images/the-racer2.jpg";

export const MovieState = () => {
  return [
    {
      title: "The Athlete",
      mainImg: athlete,
      secondaryImg: athlete2,
      url: "/work/the-athlete",
      awards: [
        {
          title: "Truly A masterpiece",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "Fresh look on a brutal sport.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "It’s okay lmao.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
      ],
    },
    {
      title: "Good Times",
      mainImg: goodtimes,
      url: "/work/good-times",
      secondaryImg: goodtimes2,
      awards: [
        {
          title: "Truly A masterpiece",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "Fresh look on a brutal sport.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "It’s okay lmao.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
      ],
    },
    {
      title: "The Racer",
      mainImg: theracer,
      url: "/work/the-racer",
      secondaryImg: theracer2,
      awards: [
        {
          title: "Truly A masterpiece",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "Fresh look on a brutal sport.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
        {
          title: "It’s okay lmao.",
          description:
            "“Lorem Ipsum is simply dummy text of the printing and typesetting industry.”",
        },
      ],
    },
  ];
};

export const questions = () => {
  return [
    {
      question: "How do I start?",
      answer1: "Lorem ipsum dolor sit amet.",
      answer2:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sit, laudantium.",
    },
    {
      question: "Daily Schedule",
      answer1: "Lorem ipsum dolor sit amet.",
      answer2:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sit, laudantium.",
    },
    {
      question: "Different Payment Methods",
      answer1: "Lorem ipsum dolor sit amet.",
      answer2:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sit, laudantium.",
    },
    {
      question: "What products do you offer?",
      answer1: "Lorem ipsum dolor sit amet.",
      answer2:
        "Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sit, laudantium.",
    },
  ];
};
